import { Injectable, inject } from '@angular/core';
import { PostCategoriesRequestQuery } from '@app/src/app/modules/post/graphql/category/post.categories.request.query';
import { PostCategoryByRequestQuery } from '@app/src/app/modules/post/graphql/category/post.category.by.request.query';
import { PostCategoryRequestQuery } from '@app/src/app/modules/post/graphql/category/post.category.request.query';
import { PostCategoryRequestMutation } from '@app/src/app/modules/post/graphql/category/post.category.request.mutation';
import { PostCategoriesPublicRequestQuery } from '@app/src/app/modules/post/graphql/category/post.categories.public.request.query';
import { PostCategoryExistsRequestQuery } from '@app/src/app/modules/post/graphql/category/post.category.exists.request.query';
import {
  buildPayload,
  DashboardGlobalConfigType,
  OptionsType,
} from '@ckmk/angular';
import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PostCategoryService {
  public readonly list = inject(PostCategoriesRequestQuery);

  public readonly single = inject(PostCategoryRequestQuery);

  public readonly manage = inject(PostCategoryRequestMutation);

  public readonly exists = inject(PostCategoryExistsRequestQuery);

  public readonly category = inject(PostCategoryByRequestQuery);

  public readonly categories = inject(PostCategoriesPublicRequestQuery);

  public constructor() {}

  public async isExists(
    route: ActivatedRouteSnapshot,
    config?: DashboardGlobalConfigType,
  ): Promise<boolean> {
    return this.exists
      .fetchQuery(
        buildPayload()
          .into('payload', (pl) =>
            pl.filters((filter) => {
              if (config) {
                filter.equalTo('id', route.params['category']);
              } else {
                filter
                  .equalTo('active', true)
                  .equalTo('slug', route.params['category']);
              }
            }),
          )
          .build(),
      )
      .then((value) => !!value);
  }

  public async manageCategoriesOptions(search?: string): Promise<OptionsType> {
    return this.list
      .fetchQuery(
        buildPayload()
          .into('payload', (bd) => {
            bd.paginate(0).filters((filter) => filter.equalTo('active', true));

            if (search) {
              bd.search(search);
            }

            return bd;
          })
          .build() as any,
      )
      .then((res) => res?.result || [])
      .then((cats) =>
        cats.map(
          (cat) =>
            ({
              label: cat.title,
              value: cat.id,
            }) as any,
        ),
      );
  }

  public async filterCategoriesOptions(search?: string): Promise<OptionsType> {
    return this.categories
      .fetchQuery(
        buildPayload()
          .into('payload', (bd) => {
            bd.filters((flt) => flt.equalTo('active', true)).paginate(0, 0);

            if (search) {
              bd.search(search);
            }

            return bd;
          })
          .build() as any,
      )
      .then((res) => res || [])
      .then((categories) =>
        categories.map(
          (category) =>
            ({
              label: category.title,
              value: category.slug,
            }) as any,
        ),
      );
  }
}
